import script from "./TranslationRecordingGame.vue?vue&type=script&setup=true&lang=js"
export * from "./TranslationRecordingGame.vue?vue&type=script&setup=true&lang=js"

import "./TranslationRecordingGame.vue?vue&type=style&index=0&id=5055a283&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5055a283"]])

export default __exports__